import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-send-recovery-password-mautic',
  templateUrl: './send-recovery-password-mautic.component.html',
  styleUrls: ['./send-recovery-password-mautic.component.scss']
})
export class SendRecoveryPasswordMauticComponent implements OnInit {

  formData: any = {};
  @ViewChild('form', { static: false }) form: ElementRef<any>;

  constructor(
    router: ActivatedRoute,
    @Inject('FORM_API_URL') public formApiUrl: string
  ) {

    router.queryParams.subscribe(
      query => {
        this.formData = query;
        // console.log(query);
        setTimeout(() => this.form.nativeElement.submit(), 500);
      }
    )

  }

  ngOnInit(): void {
  }

}
